import PropTypes from "prop-types"

import { cn } from "styles/utils"

// size - lg: collection page; sm: PDP product recommendation
const ProductDescription = ({ productName, size = "lg" }) => {
  return (
    <p
      className={cn(
        "body-sm desktop:leading-tight mb-4 truncate font-medium",
        size === "lg" && "desktop:text-16"
      )}
      title={productName}
    >
      {productName}
    </p>
  )
}

ProductDescription.propTypes = {
  productName: PropTypes.string,
  size: PropTypes.string,
}

export default ProductDescription
